/* =============================================================
   arije — Fiche produit : zoom plein ecran + correctif vignette
   Complement de produit-arije.js. Charge par le snippet de galerie.
   ============================================================= */
(function () {
  'use strict';
  if (window.__arijeZoom) return;
  window.__arijeZoom = true;

  var zoom = null;

  /* Shopify sert les images avec un parametre width : on le remonte
     pour obtenir la haute definition dans le calque de zoom. */
  function hiRes(src, w) {
    if (!src) return src;
    return /(\?|&)width=\d+/.test(src)
      ? src.replace(/((\?|&)width=)\d+/, '$1' + w)
      : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function buildZoom() {
    if (zoom) return zoom;
    var el = document.createElement('div');
    el.className = 'pz';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Vue agrandie');
    el.innerHTML =
      '<button type="button" class="pz__close" aria-label="Fermer">' +
      '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M2 2l16 16M18 2L2 18" stroke="currentColor" stroke-width="1.4"/></svg>' +
      '</button>' +
      '<div class="pz__stage"><img class="pz__img" alt=""></div>';
    document.body.appendChild(el);

    var img = el.querySelector('.pz__img');
    var stage = el.querySelector('.pz__stage');

    function close() {
      el.classList.remove('is-open', 'is-zoomed');
      document.documentElement.classList.remove('pz-lock');
      img.style.transform = '';
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }

    el.addEventListener('click', function (e) {
      if (e.target === el || e.target === stage) close();
    });
    el.querySelector('.pz__close').addEventListener('click', close);

    function pan(e) {
      if (!el.classList.contains('is-zoomed')) return;
      var r = stage.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2.4)';
    }

    stage.addEventListener('click', function (e) {
      if (e.target !== img) return;
      el.classList.toggle('is-zoomed');
      if (!el.classList.contains('is-zoomed')) img.style.transform = '';
      else pan(e);
    });
    stage.addEventListener('mousemove', pan);

    zoom = {
      open: function (src, alt) {
        img.src = hiRes(src, 2400);
        img.alt = alt || '';
        el.classList.add('is-open');
        el.classList.remove('is-zoomed');
        img.style.transform = '';
        document.documentElement.classList.add('pz-lock');
        document.addEventListener('keydown', onKey);
      }
    };
    return zoom;
  }

  function initZoom(root) {
    var frames = (root || document).querySelectorAll('.pg__frame:not([data-pz])');
    Array.prototype.forEach.call(frames, function (frame) {
      frame.setAttribute('data-pz', '');
      var img = frame.querySelector('img');
      if (!img) return; // videos et modeles 3D : pas de zoom
      frame.classList.add('pg__frame--zoomable');
      frame.addEventListener('click', function () {
        buildZoom().open(img.currentSrc || img.src, img.alt);
      });
    });
  }

  /* La vignette de la barre d'achat manquait sur les produits dont
     le premier visuel n'etait pas encore decode : currentSrc etait
     vide au moment de la construction de la barre. */
  function fixBarThumb() {
    var src = document.querySelector('.pg__item:not(.pg__item--clone) .pg__frame img');
    var box = document.querySelector('.pa-bar__thumb');
    if (!src || !box) return;
    var target = box.querySelector('img');
    if (!target) return;

    function apply() {
      var url = src.currentSrc || src.src;
      if (url) target.src = url;
      else box.style.display = 'none';
    }
    if (!target.getAttribute('src')) apply();
    if (!src.complete) src.addEventListener('load', apply, { once: true });
    target.addEventListener('error', function () { box.style.display = 'none'; });
  }

  function boot() {
    initZoom(document);
    setTimeout(fixBarThumb, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { initZoom(e.target); });
})();
